"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M12.5007 6.50075L13.833 7.5C13.833 7.5 13.5778 9.25518 11.833 11C10.0882 12.7448 7.83301 13.5 7.83301 13.5L6.83375 12.1677C6.54378 11.781 6.0188 11.6571 5.58654 11.8732L2.03136 13.6508C1.62093 13.856 1.40284 14.3142 1.50238 14.7622L2.16601 17.7485C2.26445 18.1915 2.65383 18.5152 3.1076 18.5177C14.6049 18.5806 19.4644 9.54983 19.3654 2.76029C19.3589 2.31029 19.0272 1.93885 18.5859 1.85059L15.082 1.14979C14.6398 1.06135 14.1931 1.27982 13.9914 1.68316L12.2062 5.25353C11.9901 5.6858 12.114 6.21077 12.5007 6.50075Z",
      stroke: "currentColor",
      strokeWidth: "1.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

exports.default = Icon;